// src/store/index.js
import Vue from "vue";
import Vuex from "vuex";
import notificationsServices from "../services/notifications";

Vue.use(Vuex);

export default new Vuex.Store({
    // data itself
  state: {
    notifications: [],
    unreadCount: 0,
  },

 //get data   
  getters: {
    allNotifications: state => state.notifications,
    unreadCount: state => state.unreadCount,
  },

// update states
  mutations: {
    SET_NOTIFICATIONS(state, payload) {
      state.notifications = payload;
      state.unreadCount = payload.filter(n => !n.status).length;
    },
    MARK_AS_READ(state, pk) {
      const notif = state.notifications.find(n => n.pk === pk);
      if (notif && !notif.status) {
        notif.status = "1";
        state.unreadCount--;
      }
    },
    // test 
    ADD_NOTIFICATION(state, notification) {
      state.notifications.push(notification);
      state.unreadCount++;
    },
  },
 // calls the api and commit the mutations
  actions: {
    async getNotifications({ commit }) {
        await notificationsServices.getNotifications().then((data)=>{      
          console.log(data);
            commit("SET_NOTIFICATIONS", data);
        }).catch(err=>{
          if(err.message=='1')
            commit("SET_NOTIFICATIONS", []);
        })
    },

    async markNotificationRead({ commit }, pk) {
        await notificationsServices.upadateNotification(pk).then(data=>{
          commit("MARK_AS_READ", pk);
        }).catch((err) =>{
        console.error("Failed to mark notification as read", err);
      });
    },
    // test 
    handleNewNotification({ commit }, notification) {
      // Extract notification details
      // const notification = {
      //   id: payload.data.id || Date.now(),
      //   title: payload.notification.title,
      //   body: payload.notification.body,
      //   read: false,
      // };
      commit("ADD_NOTIFICATION", JSON.parse(notification));
    },
  },
});
